function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M338 0h1258c93 0 178 38 239 99s99 146 99 239v2657c0 93-38 178-99 239s-146 99-239 99H338c-93 0-178-38-239-99S0 3088 0 2995V338c0-93 38-178 99-239S245 0 338 0zm447 3065c-22 0-41-18-41-41 0-22 18-41 41-41h372c22 0 41 18 41 41 0 22-18 41-41 41H785zM750 194c36 0 65 29 65 65s-29 65-65 65-65-29-65-65 29-65 65-65zm217 0c36 0 65 29 65 65s-29 65-65 65-65-29-65-65 29-65 65-65zm217 0c36 0 65 29 65 65s-29 65-65 65-65-29-65-65 29-65 65-65zM81 2693h1772V521H81v2172zm1772 81H81v220c0 71 29 135 76 181 47 47 111 76 181 76h1258c71 0 135-29 181-76 47-47 76-111 76-181v-220zM81 439h1772V338c0-71-29-135-76-181-47-47-111-76-181-76H338c-71 0-135 29-181 76-47 47-76 111-76 181v101z",
  fillRule: "nonzero"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1934 3333",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.dc1970f6.svg";
export { ForwardRef as ReactComponent };